import React, { memo } from 'react'
import { Grid } from '@mui/material'
import { Trans } from 'react-i18next'

import Text from '../shared/text/Text'
import BaseCard from '../shared/baseCard/BaseCard'
import DefaultText from '../shared/text/DefaultText'
import DisplayStats from './DisplayStats'
import { APP_WEB3_STATS } from '../../constants/app'
import { formatTicks } from '../../util/string.helpers'

const Partners = ({ t }) => {
  const statsData = Object.keys(APP_WEB3_STATS).map((key) => {
    return {
      label: t(`intro.stats.${key}`),
      value: `${formatTicks(APP_WEB3_STATS[key])}+`
    }
  })

  return (
    <BaseCard>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={5}>
              {/* <Text
                variant='h2'
                label={t('intro.introduction-about-us')}
                fontWeight={700}
              /> */}
              <Text
                variant='h2'
                label={t('intro.what-is-qb')}
                fontWeight={900}
                sx={{ fontSize: '2.625rem', mt: 0.5 }}
              />
              <DefaultText label={<Trans i18nKey='intro.description' />} />
            </Grid>
            <Grid item xs={0} sm={1}></Grid>
            <Grid item xs={12} sm={6}>
              <Text
                variant='h2'
                label={t('intro.key-stats')}
                fontWeight={700}
                sx={{ mb: 1 }}
              />
              <DisplayStats
                data={statsData}
                reverseTitle
                gridProps={{ spacing: 2 }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ textAlign: 'center' }}>
          <Text
            variant='h2'
            label={t('intro.strategic-partners')}
            fontWeight={700}
          />
          <Text
            variant='h2'
            label={t('intro.amplifying-ecosystem')}
            fontWeight={900}
            sx={{ fontSize: '2.625rem', mt: 0.5, mb: 5 }}
          />
          <Grid container spacing={2} alignItems='center'>
            {[...Array(12).keys()].map((image, index) => (
              <Grid item key={index} xs={6} sm={3} md={2}>
                <img
                  src={require(`../../assets/partners/${image + 1}.png`)}
                  style={{ maxHeight: 120, maxWidth: 120 }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </BaseCard>
  )
}

export default memo(Partners)
